export default {};



// WEBPACK FOOTER //
// ./src/components/account/account.js